import { Component } from "@mna/react";
import { Trans } from "react-i18next";
import i18n from "./../../../i18n";
import { backClick } from "./Single";
import {  checkAndGetLocalStorageValue} from "../../../features/utils";
let lang, isQuestionLog;
let selectedId;

async function answerClick({
  state,
  actions,
  setState,
  nextStepName,
  history,
  item,
}) {  
  gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
  actions.addPresentQuestion({ item });
  await actions.postQuestions(state, actions, setState);
  if (state.Questions.should_stop === true) {
    state.triageRequest.activeMenu = nextStepName;
  }
  state.Questions.should_stop === false
    ? actions.getQuestions(
        { state, actions, setState, nextStepName, history },
        (lang = i18n.language),
        (isQuestionLog = true)
      )
    : actions.finishQuestionCallback(
        state,
        nextStepName,
        history,
        actions,
        setState,
        state.Questions,
        lang
      );
}

export default class GroupSingle extends Component {
  constructor() {
    super();
    this.state = {
      globalAnswerAvailable: false,
    };
  }

  componentWillMount() {
    const { state } = this.props;    
    for (var i = 0; i < state.Questions.question.items.length; i++) {
      var presentTemp = state.presentQuestionsSelectedTemp.indexOf(
        state.Questions.question.items[i].id
      );

      selectedId = state.presentQuestionsSelectedTemp[presentTemp];

      if (presentTemp !== -1) {
        this.setState({
          globalAnswerAvailable: true,
        });
        break;
      }
    }
  }

  componentWillUnmount() {
    this.setState({
      globalAnswerAvailable: false,
    });
  }

  render() {
    const { state, actions, history, setState, nextStepName } = this.props;
    const uuidv4 = require("uuid/v4");
    const groupSingleId = "group_single_" + uuidv4();
    return (
      <div className="standby-questions-margin">
        <h1 className="text-left">
          {state.Questions.question.text}
        </h1>
        <div>
        
          <ul className="standby-symptom-list">
            {state.Questions.question.items.map(function (item) {
              var presentTemp = state.presentQuestionsSelectedTemp.indexOf(
                item.id
              );
              return (
                <li id={`list_${item.id}`} className="radio-button-interview">
                  <input
                    type="radio"
                    name={groupSingleId}
                    id={item.id}
                    key={"key_"+item.id}
                    value={item.name}
                    defaultChecked={presentTemp > -1}
                    className="standby-triagesymptom"
                    aria-label={state.Questions.question.text + " " + item.name}
                    onChange={(e) =>{
                      setState({
                        itemSelected: e.currentTarget.id
                      })
                    }}
                  />
                  <label for={item.id}>{item.name}</label>
                </li>
              );
            })}
          </ul>
        </div>
        <div className="standby-page-section-row standby-page-section-row-flex standby-page-section-row-flex-spaced standby-page-section-row-flex-align-center standby-form-fieldset">
          <div className=" standby-btn-next standby-col standby-col-shrink ">
            {state.presentQuestionsSelected.length > 0 ||
            state.unknownQuestionsSelected.length > 0 ||
            state.absentQuestionsSelected.length > 0 ? (
              <button
                type="button"
                className="button standby-button standby-button-gradient standby-button-gradient-green"
                onClick={() =>
                  backClick({ state, actions, setState, nextStepName, history })
                }
              >
                <Trans i18nKey="findcareoption.questions.Back"> Back</Trans>
              </button>
            ) : null}

            {(
              <button
                type="button"
                className="standby-btn-back button standby-button standby-button-gradient standby-button-gradient-green"
                onClick={() => {
                    if(this.state.globalAnswerAvailable)
                  {
                    if(selectedId && !state.itemSelected) {
                      var item = {
                      id: selectedId,
                    };} else{
                      var item = {
                        id: state.itemSelected,
                      };
                    }
                  answerClick({
                    state,
                    actions,
                    setState,
                    nextStepName,
                    history,
                    item,
                  });}else{
                    if(state.itemSelected)
                    {var item = {
                      id: state.itemSelected,
                    };
                    answerClick({
                          state,
                          actions,
                          setState,
                          nextStepName,
                          history,
                          item,
                        });}
                  }
                }
                }
              >
                <Trans i18nKey="findcareoption.questions.Next"> Next</Trans>
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}
